/** Formats a Trickpark session duration ("125" → "2m 5s"). */
export const formatTrickparkDuration = (seconds?: number | null): string => {
  if (!seconds && seconds !== 0) return '-';
  const minutes = Math.floor(seconds / 60);
  const remaining = seconds % 60;
  return minutes > 0 ? `${minutes}m ${remaining}s` : `${remaining}s`;
};

/** Trims "13:30:30" to "13:30". */
export const formatTrickparkTime = (time?: string): string =>
  (time || '').slice(0, 5);
